import { CheckCircle2 } from "lucide-react";
import { hardRefresh } from "@/utils/hardRefresh";

interface Props {
  open: boolean;
  wasDeployment?: boolean;
  onCancel?: () => void;
}

export function MaintenanceEndedModal({ open, wasDeployment = false, onCancel }: Props) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4">
      <div className="bg-[var(--color-bg-surface)] border border-[var(--color-border)] rounded-xl w-full max-w-sm p-6 text-center space-y-4 shadow-2xl">
        <div className="flex justify-center">
          <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle2 size={30} className="text-green-600" />
          </div>
        </div>
        <div>
          <h2 className="text-base font-bold text-[var(--color-text-primary)]">
            {wasDeployment ? "Wdrożenie zakończone" : "Przerwa techniczna zakończona"}
          </h2>
          <p className="mt-1 text-sm text-[var(--color-text-secondary)]">
            {wasDeployment ? "Pobieramy nową wersję strony." : "System wznowił działanie."}
          </p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 py-2 border border-[var(--color-border)] text-[var(--color-text-secondary)] text-sm font-semibold rounded-lg hover:bg-[var(--color-bg-subtle)] transition-colors"
          >
            Anuluj
          </button>
          <button
            onClick={hardRefresh}
            className="flex-1 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-semibold rounded-lg transition-colors"
          >
            Odśwież teraz
          </button>
        </div>
      </div>
    </div>
  );
}
